import { useEffect, useState } from 'react';
import { apiBase } from './api';
import type { Envelope } from './types';

export interface Promo { active: boolean; badge: string; note: string }
export interface PricingInfo { monthlyEur: string; annualEur: string; promo: Promo }

/** Default mirrors the backend default so the UI is correct before /api/pricing resolves. */
const DEFAULT: PricingInfo = {
  monthlyEur: '20',
  annualEur: '200',
  promo: { active: false, badge: 'Early access', note: 'Early-access price. It stays yours for as long as your subscription is active.' },
};

// Module-level cache so every component shares one fetch (price rarely changes).
let cache: Promise<PricingInfo> | null = null;
function fetchPricing(): Promise<PricingInfo> {
  if (!cache) {
    cache = fetch(`${apiBase}/pricing`)
      .then((r) => r.json() as Promise<Envelope<PricingInfo>>)
      .then((j) => (j.ok ? j.data : DEFAULT))
      .catch(() => DEFAULT);
  }
  return cache;
}

/** Admin-driven Pro price + promo. Returns the default until the fetch resolves. */
export function usePricing(): PricingInfo {
  const [p, setP] = useState<PricingInfo>(DEFAULT);
  useEffect(() => {
    let live = true;
    void fetchPricing().then((v) => { if (live) setP(v); });
    return () => { live = false; };
  }, []);
  return p;
}
